import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgButtonWrap = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 5,
	height: 40,
	viewBox: "0 0 5 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M5 40H0V35H1L1 39H5V40Z",
			fill: "#FAFAE5"
		}),
		/* @__PURE__ */ _jsx("rect", {
			y: 5,
			width: 1,
			height: 30,
			fill: "#FAFAE5",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5 0H0V5H1L1 1H5V0Z",
			fill: "#FAFAE5"
		})
	]
});
export { SvgButtonWrap as ReactComponent };
